import Icon from '../components/Icon.vue'

Icon.register({
  toolbox: {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M502.6 214.6c6 6 9.4 14.1 9.4 22.6v82.8h-128v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16h-128v-16c0-8.8-7.2-16-16-16h-32c-8.8 0-16 7.2-16 16v16h-128v-82.7c0-8.5 3.4-16.6 9.4-22.6l45.3-45.3c6-6 14.1-9.4 22.6-9.4h50.8v-80c0-26.5 21.5-48 48-48h160c26.5 0 48 21.5 48 48v80h50.8c8.5 0 16.6 3.4 22.6 9.4zM320 160v-64h-128v64h128zM384 368v-16h128v96c0 17.7-14.3 32-32 32h-448c-17.7 0-32-14.3-32-32v-96h128v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16v-16h128v16c0 8.8 7.2 16 16 16h32c8.8 0 16-7.2 16-16z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/toolbox.js
// module id = 2017
// module chunks = 0